import { TranslateResources } from './translateCodes';

const translation: Partial<TranslateResources> = {
    MINS: 'mins',
    YOUR_EMAIL: 'Your Email',
    PHONE: 'Phone number',
    CONTINUE: 'Continue',
    TRANSACTION_DETAILS: 'Détails de la transaction',
    CLIENT_NAME: 'Nom du client',
    PHONE_NUMBER: 'Numéro de téléphone',
    PAYMENT_TYPE: 'Type de paiement',
    SALE_ID: 'ID de vente',
    DESCRIPTION: 'Description',
    PRICE: 'Prix',
    SERVICE: 'Service',
    PRODUCT: 'Produit',
    SUB_TOTAL: 'Sous-total',
    DISCOUNT: 'Remise',
    TAX: 'Taxe',
    TIP: 'Pourboire',
    TOTAL_AMOUNT: 'Montant total',
    RATE_EXPERIENCE: 'Veuillez évaluer votre expérience avec',
    GIVE_FEEDBACK: 'Donner un avis',
    ENTER_FEEDBACK: 'Entrez votre avis',
    SUBMIT: 'Soumettre',
    VIEW_TRANSACTION_DETAILS: 'Voir les détails de la transaction',
    WE_LOVE_FEEDBACK: 'Nous aimerions avoir votre avis !',
    SHARE_EXPERIENCE_GOOGLE: 'Partagez votre expérience sur Google et aidez d’autres personnes à découvrir nos services.',
    CLICK_TO_REVIEW: 'Cliquez pour donner votre avis !',
    REVIEW_EXISTS: 'L’avis existe déjà',
    SALE_REVIEWED: 'La vente a été évaluée',
    THANK_FOR_FEEDBACK: 'Merci d’avoir partagé votre avis !',
    FEEDBACK_RECEIVED: 'Nous avons bien reçu votre retour et apprécions grandement votre contribution à notre amélioration.',
};

export const fr = {
    translation,
};
